<template>
  <lb-drawer
    data-testid="task-upload-modal"
    v-model="drawerVisible"
    :heading="bulkworkpaper ? 'File Bulk Upload' : 'Single File Upload'"
    width="500"
    persistent
  >
    <template v-slot:body>
      <div data-testid="task-upload-modal__header" class="d-flex align-center justify-space-between mb-4">
        <h5 data-testid="task-upload-modal__title">Upload your document</h5>
        <v-btn
          data-testid="task-upload-modal__download-template-btn"
          class="secondaryBtn"
          v-if="allowedTaskTypes"
          @click="$nova.downloadFile('', {}, '/v2/financialclose/analysis/gettasklisttemplateV3')"
        >
          <v-icon data-testid="task-upload-modal__download-icon">mdi-download</v-icon><span> Download Template</span>
        </v-btn>
      </div>
      <DragDropfile
        data-testid="task-upload-modal__drag-drop"
        class="d-cont"
        hidedetails
        :files="localFileuplaoded"
        @update:files="FilesUpload"
        :resetTrigger="resetFlag"
      />
      <p data-testid="task-upload-modal__remark-label" class="gray--text ma-0 mt-3">Remark {{ localUploadWithoutFile ? '(required)' : '(optional)' }}</p>
      <lb-textBox
        data-testid="task-upload-modal__remark-input"
        requriedrows="3"
        :hidedetails="true"
        v-model="localFileremark"
        label="Input"
      />
    </template>
    <template v-slot:actions>
      <v-checkbox
        data-testid="task-upload-modal__without-doc-checkbox"
        label="Upload without document"
        hide-details
        class="ma-0"
        v-model="localUploadWithoutFile"
      />
      <v-spacer></v-spacer>
      <div data-testid="task-upload-modal__bulk-actions" v-if="bulkworkpaper">
        <template>
          <v-btn
            data-testid="task-upload-modal__bulk-remark-submit-btn"
           
            class="ml-2 white--text"
            color="primary"
            v-if="!filesOnly && localUploadWithoutFile"
            @click="sendForReviewBulk()"
            :loading="sendforreviewloadingbulk"
            :disabled="!localFileremark"
          ><span data-testid="task-upload-modal__bulk-remark-submit-label">{{ uploadActionLabel }}</span></v-btn>
          <v-btn
            data-testid="task-upload-modal__bulk-upload-btn"
           
            class="ml-2 white--text"
            color="primary"
            :loading="sendforreviewloadingbulk"
            v-else
            @click="uploadFilesBulk()"
          ><span data-testid="task-upload-modal__bulk-upload-label">{{ uploadActionLabel }}</span></v-btn>
        </template>
      </div>
      <div data-testid="task-upload-modal__single-actions" v-else>
        <template>
          <v-btn
            data-testid="task-upload-modal__single-remark-submit-btn"
           
            class="ml-2 white--text"
            color="primary"
            v-if="!filesOnly && localUploadWithoutFile"
            :loading="sendforreviewloading || submitLoading"
            @click="sendForReview()"
            :disabled="(viewtaskdata && viewtaskdata.stage === 3) || !localFileremark"
          ><span data-testid="task-upload-modal__single-remark-submit-label">{{ uploadActionLabel }}</span></v-btn>
          <v-btn
            data-testid="task-upload-modal__single-upload-btn"
           
            class="ml-2 white--text"
            color="primary"
            v-else
            @click="handleUploadClick(false)"
            :loading="sendforreviewloading || submitLoading"
            :disabled="viewtaskdata && viewtaskdata.stage === 3"
          ><span data-testid="task-upload-modal__single-upload-label">{{ uploadActionLabel }}</span></v-btn>
        </template>
      </div>
    </template>
  </lb-drawer>
</template>

<script>
import DragDropfile from '@/views/Inputs/DragDropfile.vue';
import { TASK_UPLOAD_LABELS, COMPONENT_EVENTS } from '@/modules/financialclose/utils/constants';

export default {
  name: 'TaskListModel',
  components: {
    DragDropfile
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    },
    bulkworkpaper: Boolean,
    fileuplaoded: Array,
    resetFlag: Boolean,
    fileremark: String,
    uploadWithoutFile: Boolean,
    viewtaskdata: Object,
    fileNamesList: Array,
    filesOnly: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      required: true
    },
    task: {
      type: Object,
      required: true
    },
    // For bulk mode: pass the currently selected tasks from parent (array of task objects)
    selectedTasks: {
      type: Array,
      default: () => []
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  // Add event emits: bulk-upload-complete, clear-selected
  // (update:modelValue already present)
  data() {
    return {
      modifiedname: 'Modified File Name', // Placeholder for modified file name
      fileprocessing: {},
      files: {},
      filesbulk: {},
      sendforreviewloading: false,
      sendforreviewloadingbulk: false,
      submitLoading: false,
      bulkfilesloading: 0,
      clearuploadfiledata: false,
      sendForReviewDialogbulk: false,
      bulkworkpaperupload: false,
      log: 0,
      loading: false,
      localFileuplaoded: this.fileuplaoded || [],
      file: null,
      dataArray: [],
      selectItem: [],
      checklist: {},
      // File upload restrictions (extensions and size)
      ALLOWED_EXTENSIONS: [
        'xlsm', 'xlsx', 'csv', 'xlsb', 'xls', 'pdf', 'txt', 'xml',
        'jpeg', 'jpg', 'png', 'mp4', 'doc', 'docx', 'readme', 'svg', 'ppt', 'pptx'
      ],
      MAX_TOTAL_SIZE: 25 * 1024 * 1024, // 25 MB
      localUploadWithoutFile: this.uploadWithoutFile, // local copy for v-model
      localFileremark: this.fileremark, // local copy for v-model
      localResetFlag: this.resetFlag, // local copy for resetFlag
      taskTypes: this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION
    };
  },
  watch: {
    selectedTasks: {
      handler(newVal){
        if (Array.isArray(newVal)) {
          this.selectItem = newVal;
        }
      },
      immediate: true,
      deep: false
    },
    fileuplaoded(newVal) {
      this.localFileuplaoded = newVal || [];
    },
    drawerVisible(val) {
      if (!val) {
        // When closing, clear files and reset
        this.localFileuplaoded = [];
        // Force new array reference for reactivity
        this.localFileuplaoded = [...this.localFileuplaoded];
        this.$nextTick(() => {
          this.localResetFlag = !this.localResetFlag;
        });
      }
    },
    resetFlag(newVal) {
      this.localResetFlag = newVal;
    },
    uploadWithoutFile(newVal) {
      this.localUploadWithoutFile = newVal;
    },
    localUploadWithoutFile(newVal) {
      this.$emit(COMPONENT_EVENTS.UPDATE_UPLOAD_WITHOUT_FILE, newVal);
    },
    fileremark(newVal) {
      this.localFileremark = newVal;
    },
    localFileremark(newVal) {
      this.$emit(COMPONENT_EVENTS.UPDATE_FILE_REMARK, newVal);
    }
  },
  computed: {
    allowedTaskTypes() {
      return this.taskTypes === this.task.task_type;
    },
    // True when task is NOT account reconciliation (i.e., Normal Task)
    isNormalTask() {
      return this.task && this.task.task_type !== this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
    },
    taskData() {
      return this.$store.getters['tasks/getCurrentTask'] || {};
    },
    drawerVisible: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit(COMPONENT_EVENTS.UPDATE_MODEL_VALUE, val);
      }
    },
    // Determine when to show "Upload & Submit"
    // Rules added: If no_of_evidence == 0 we still allow Upload & Submit with either a new file OR remark-only (upload without document + remark)
    showUploadAndSubmit() {
      if (this.filesOnly) return false;
      // Restrict Upload & Submit to Normal Tasks only
      const RECON = this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
      if (this.bulkworkpaper) {
        // In bulk mode, all selected tasks must be normal
        const items = Array.isArray(this.selectItem) ? this.selectItem : [];
        if (!items.length) return false;
        if (!items.every(t => t && t.task_type !== RECON)) return false;
      } else {
        if (!this.isNormalTask) return false;
      }
      // NOTE: localFileuplaoded is the data property tracking selected files
      const newCount = Array.isArray(this.localFileuplaoded) ? this.localFileuplaoded.length : 0;
      const isRemarkOnly = this.localUploadWithoutFile === true;
      const hasRemark = !!(this.localFileremark && this.localFileremark.trim().length);

      // Bulk mode
      if (this.bulkworkpaper) {
        if (!Array.isArray(this.selectItem) || this.selectItem.length === 0) return false;
        const tasks = this.selectItem.filter(t => t); // valid tasks
        if (!tasks.length) return false;
          // Separate tasks with positive requirement and zero requirement
          const positiveReq = tasks.filter(t => Number.isFinite(t.no_of_evidence) && t.no_of_evidence > 0);
          // For tasks with positive requirement ensure satisfied (existing + new >= required)
          const positivesSatisfied = positiveReq.every(t => {
          const existing = Array.isArray(t.upload_v2) ? t.upload_v2.length : 0;
          return (existing + newCount) >= t.no_of_evidence;
        });
        if (!positivesSatisfied) return false;
        // Require at least one new file for positive requirement satisfaction; zero-requirement tasks can still use remark-only.
        const trigger = (newCount > 0) || (isRemarkOnly && positiveReq.length === 0);
        return trigger;
      }

      // Single task
      const required = (this.task && Number.isFinite(this.task.no_of_evidence)) ? this.task.no_of_evidence : 0;
      const existingCount = Array.isArray(this.task?.upload_v2) ? this.task.upload_v2.length : 0;
      if (required > 0) {
        // Require at least one newly added file to trigger Upload & Submit for evidence-based tasks
        if (newCount === 0) return false;
        return (existingCount + newCount) >= required && (!isRemarkOnly || hasRemark || newCount > 0);
      } else { // required == 0
        // Show as soon as either a file selected or remark-only chosen (remark text may still be empty, button disabled until filled)
        return (newCount > 0) || isRemarkOnly;
      }
    },
    // Single source for button label
    uploadActionLabel() {
      if (this.filesOnly) return TASK_UPLOAD_LABELS.UPLOAD;
      return this.showUploadAndSubmit && this.pageType !== 'task-detail' ? TASK_UPLOAD_LABELS.UPLOAD_AND_SUBMIT : TASK_UPLOAD_LABELS.UPLOAD;
    }
  },
  methods: {
    // Determine which tasks are eligible for auto-submit based on evidence rules and task type
    getSubmitTargets(tasks, newFilesCount) {
      const RECON = this.$constants.TASK_LIST_CONSTANTS.TASK_TYPES.ACCOUNT_RECONCILIATION;
      const list = (Array.isArray(tasks) ? tasks : [tasks]).filter(t => t && t._id);
      return list.filter(taskItem => {
        if (taskItem.stage === 3) return false; // already submitted/closed
        if (taskItem.task_type === RECON) return false; // skip reconciliation tasks
        if (Number.isFinite(taskItem.no_of_evidence) && taskItem.no_of_evidence > 0) {
          const existingCount = Array.isArray(taskItem.upload_v2) ? taskItem.upload_v2.length : 0;
          if ((existingCount + newFilesCount) < taskItem.no_of_evidence) return false; // not satisfied yet
        }
        return true;
      });
    },
    // Auto submit a set of targets; returns detailed result object
    async autoSubmitTasks(targets) {
      const submitPromises = targets.map(taskItem => this.$store
        .dispatch('tasks/submitTask', { taskId: taskItem._id, cycleId: taskItem.project, suppressSnackbar: targets.length > 1 })
        .then(result => ({ taskId: taskItem._id, status: result?.status || 'error' }))
        .catch(errorObj => ({ taskId: taskItem._id, status: 'error', message: errorObj?.message }))
      );
      return Promise.all(submitPromises);
    },
    // Unified post-upload handler for both single and bulk modes
    async afterUploadSuccess({ tasks, newFilesCount, isBulk, attemptAutoSubmit }) {
      const taskArray = Array.isArray(tasks) ? tasks : [tasks];
      if (!attemptAutoSubmit) {
        // For single upload without submit attempt, nothing extra
        return;
      }
      if (isBulk) {
        // Bulk auto-submit logic replicating previous behavior
        const targets = this.getSubmitTargets(taskArray, newFilesCount);
        if (!targets.length) return; // nothing eligible
        const submitResults = await this.autoSubmitTasks(targets);
        const successIds = submitResults.filter(r => r.status === 'success').map(r => r.taskId);
        const failedIds = submitResults.filter(r => r.status !== 'success').map(r => r.taskId);
        if (successIds.length) {
          const successRefs = targets.filter(t => successIds.includes(t._id)).map(t => t.ref || t._id).join(', ');
          this.$store.commit('sbSuccess', `Uploaded & Submitted: ${successRefs}`);
        } else if (!failedIds.length) {
          this.$store.commit('sbSuccess', 'Files uploaded');
        }
        if (failedIds.length) {
          const failedRefs = targets.filter(t => failedIds.includes(t._id)).map(t => t.ref || t._id).join(', ');
            this.$store.commit('sbError', `Submit failed: ${failedRefs}`);
        }
        const submittedIds = new Set(targets.map(t => t._id));
        const notSubmitted = taskArray.filter(t => t && t._id && !submittedIds.has(t._id));
        if (notSubmitted.length) {
          const refs = notSubmitted.map(t => t.ref || t._id).join(', ');
          this.$store.commit('sbWarning', `The following tasks: ${refs} were not submitted due to missing evidences. Please upload the required evidences for each task.`);
        }
      } else {
        // Single task auto-submit: replicate previous flow (existing snackbar from submitTask when suppressSnackbar false)
        const taskObj = taskArray[0];
        const eligible = this.getSubmitTargets(taskObj, newFilesCount);
        if (!eligible.length) return; // not eligible yet
        try {
          await this.$store.dispatch('tasks/submitTask', { taskId: taskObj._id, cycleId: taskObj.project, suppressSnackbar: false });
        } catch (e) { /* error snackbar already shown by action */ }
      }
    },
    async handleSubmitTask() {
      if (this.submitLoading) return; // prevent double clicks
      this.submitLoading = true;
      try {
        const cycleId = this.task.project;
        const taskId = this.task._id;
        if (!cycleId || !taskId) throw new Error('Missing cycle or task ID');
        const response = await this.$store.dispatch('tasks/submitTask', { taskId, cycleId });
        if (response?.status === 'success') {
          // Store action already fired success snackbar
          this.$emit(COMPONENT_EVENTS.TASK_SUBMITTED, response);
          this.$emit(COMPONENT_EVENTS.REFRESH);
        }
        return response;
      } catch (err) {
        // Error snackbar already handled in Vuex action; swallow here
        return { status: 'error', message: err?.message };
      } finally {
        this.submitLoading = false;
      }
    },
    async handleUploadClick(isRemarkOnly){
      const newCount = Array.isArray(this.localFileuplaoded) ? this.localFileuplaoded.length : 0;
      const shouldSubmit = this.showUploadAndSubmit && !(this.task && this.task.stage === 3);
      // Guard: prevent submit path if no new files were selected for evidence-required tasks
      if (shouldSubmit && newCount === 0 && this.task && Number.isFinite(this.task.no_of_evidence) && this.task.no_of_evidence > 0) {
        // Just close or notify; choose notify for clarity
        this.$store.commit('sbError', 'Please add file(s) before submitting.');
        return;
      }
      const suppressUploadSnackbar = shouldSubmit; // if we're auto-submitting, suppress upload success toast
      const success = this.filesOnly 
        ? await this.uploadFiles()
        : (isRemarkOnly 
            ? await this.sendForReview() 
            : await this.uploadFilesInternal(suppressUploadSnackbar));
      if (!success) return; // abort if failed
      await this.afterUploadSuccess({ tasks: this.task, newFilesCount: newCount, isBulk: false, attemptAutoSubmit: shouldSubmit });
      // Close drawer after operations
      this.drawerVisible = false;
      this.$emit(COMPONENT_EVENTS.REFRESH);
    },
    showFileLimitError(msg) {
      this.$store.commit('sbError', msg);
    },
    reset() {
      // Clear all local file and remark data
      this.localFileuplaoded = [];
      this.localFileremark = '';
      this.localUploadWithoutFile = false;
      this.files = {};
      this.filesbulk = {};
      this.dataArray = [];
      this.selectItem = [];
      this.bulkfilesloading = 0;
      this.clearuploadfiledata = false;
      this.sendForReviewDialogbulk = false;
      this.bulkworkpaperupload = false;
      this.log = 0;
      this.loading = false;
      this.localResetFlag = !this.localResetFlag;
      // Optionally emit to parent if you want parent to reset too
      this.$emit(COMPONENT_EVENTS.RESET);
    },
    async sendForReview() {
      if (this.sendforreviewloading) return false;
      this.sendforreviewloading = true;
      try {
        // Guard: this method only used when 'Upload without document' checkbox is selected
        if (this.filesOnly) {
          return false; // filesOnly mode shouldn't route here
        }
        if (!this.localUploadWithoutFile) {
          // Not in remark-only mode; nothing to do
            return false;
        }
        if (!this.localFileremark) {
          this.$store.commit('sbError', 'Remark is mandatory when uploading without a document.');
          return false;
        }
        // Determine if we will auto-submit; if so suppress remark snackbar to avoid duplicate
        const willAutoSubmit = this.showUploadAndSubmit && !this.filesOnly && this.localUploadWithoutFile && this.task && this.task.stage !== 3;
        const fileuploadstatus = await this.$store.dispatch('tasks/sendForReview', {
          id: this.id,
          viewtaskdata: this.task,
          remark: this.localFileremark,
          isFileValid: this.isFileValid,
          suppressSnackbar: willAutoSubmit
        });
        if (fileuploadstatus && fileuploadstatus.success) {
          if (willAutoSubmit) {
            try {
              await this.$store.dispatch('tasks/submitTask', { taskId: this.task._id, cycleId: this.task.project, suppressSnackbar: false });
              this.$emit(COMPONENT_EVENTS.TASK_SUBMITTED);
            } catch (e) {
              // Snackbar handled by Vuex action
            }
          }
          this.drawerVisible = false;
          this.$emit(COMPONENT_EVENTS.REFRESH);
          return true;
        } else {
          const reviewError = fileuploadstatus && fileuploadstatus.error;
          this.$store.commit('sbError', reviewError || 'Error Adding Remarks.');
          return false;
        }
      } finally {
        this.sendforreviewloading = false;
      }
    },
    async sendForReviewBulk() {
      if (this.sendforreviewloadingbulk) return;
      this.sendforreviewloadingbulk = true;
      try {
        // Determine if we expect auto-submit (remark-only bulk, and Upload & Submit visible logic)
        const willAutoSubmit = this.showUploadAndSubmit && this.localUploadWithoutFile && !this.filesOnly;
        await this.$store.dispatch('tasks/sendForReviewBulk', {
          id: this.id,
          selectItem: this.selectItem,
          localFileremark: this.localFileremark,
          viewtaskdata: this.task,
          isFileValid: this.isFileValid,
          suppressSnackbar: willAutoSubmit
        });
        // Auto-submit for bulk remark-only when Upload & Submit condition is met
        const tasksArray = (Array.isArray(this.selectItem) && this.selectItem.length) ? this.selectItem : [];
        if (willAutoSubmit && tasksArray.length > 0) {
          try {
            await this.afterUploadSuccess({ tasks: tasksArray, newFilesCount: 0, isBulk: true, attemptAutoSubmit: true });
          } catch (e) { /* handled internally */ }
        }
        this.$emit(COMPONENT_EVENTS.BULK_UPLOAD_COMPLETE);
        this.$emit(COMPONENT_EVENTS.UPDATE_MODEL_VALUE, false);
        this.$emit(COMPONENT_EVENTS.REFRESH);
      } finally {
        this.sendforreviewloadingbulk = false;
      }
    },
    FilesUpload(filesss) {
      // Always treat filesss as an array
      const filesArray = Array.isArray(filesss) ? filesss : [filesss];
      let invalidExt = false;
      let invalidFiles = [];
      let invalidNames = [];
      // Clone currently selected local files
      let mergedFiles = [...this.localFileuplaoded];
      // Track only duplicates against already-uploaded files for user warning.
      // Local re-selections (same file picked again before confirming) will be silently replaced without warning.
      const existingDuplicateNames = []; // duplicates of already uploaded files
      // Collect already uploaded filenames (single or bulk) - case-insensitive
      const existingUploadedNames = (() => {
        const extract = task => Array.isArray(task?.upload_v2) ? task.upload_v2.map(f => (f.file_name || f.modifiedname || '').trim()) : [];
        let all = [];
        if (this.bulkworkpaper) {
          (this.selectItem || []).forEach(t => { all.push(...extract(t)); });
        } else {
          all = extract(this.task);
        }
        return Array.from(new Set(all.filter(Boolean).map(n => n.toLowerCase())));
      })();
      filesArray.forEach(file => {
        if (!file || !file.name) return;
        const name = file.name;
        const norm = name.toLowerCase().trim();
        // Validate name
        if (this.$nova && this.$nova.isValidFileName && !this.$nova.isValidFileName(name)) {
          invalidNames.push(name);
        }
        const ext = name.split('.').pop().toLowerCase();
        if (!this.ALLOWED_EXTENSIONS.includes(ext)) {
          invalidExt = true;
          invalidFiles.push(name);
        }
        // Local duplicate replace
        const localIdx = mergedFiles.findIndex(f => f.name && f.name.toLowerCase() === norm);
        if (localIdx !== -1) {
          // Silently replace previously selected (not yet uploaded) file with same name
          mergedFiles.splice(localIdx, 1, file);
          return; // do not flag as duplicate for user-facing warning
        }
        // Already uploaded duplicate (warn & allow replacement upload)
        if (existingUploadedNames.includes(norm)) {
          existingDuplicateNames.push(name);
          mergedFiles.push(file);
          return;
        }
        mergedFiles.push(file);
      });
      // Compute total size of final local selection
      const totalSize = mergedFiles.reduce((sum, f) => sum + (f.size || 0), 0);
      if (invalidNames.length > 0) {
        this.$store.commit(
          'sbError',
          `Invalid file name(s): ${invalidNames.join(', ')}. Only letters, numbers, spaces, underscores (_), hyphens (-), dots (.), or parentheses () are allowed.`
        );
        return;
      }
      if (invalidExt) {
        this.$store.commit(
          'sbError',
          `Only the following file types are allowed: ${this.ALLOWED_EXTENSIONS.join(', ')}. Invalid: ${invalidFiles.join(', ')}`
        );
        return;
      }
      if (totalSize > this.MAX_TOTAL_SIZE) {
        this.$store.commit(
          'sbError',
          `Total file size exceeds the limit (${(this.MAX_TOTAL_SIZE / (1024 * 1024)).toFixed(2)} MB)`
        );
        return;
      }
      // Only warn user when a file name matches an already uploaded file (server-side duplicate)
      if (existingDuplicateNames.length > 0) {
        this.$store.commit('sbWarning', `These file(s) are already uploaded and will be replaced: ${existingDuplicateNames.join(', ')}`);
      }
      if (this.bulkuploadtemplate) {
        this.file = filesArray[0];
        this.readFile("file");
      } else {
        this.localFileuplaoded = mergedFiles;
      }
    },
    async uploadFiles() {
      this.sendforreviewloading = true;
      try {
        await this.$store.dispatch('tasks/uploadFiles', {
          id: this.id,
          files: this.localFileuplaoded,
          taskData: this.task,
          projectId: this.id,
          upload_v2: this.task.upload_v2,
          isFileValid: this.isFileValid,
          remark: this.localFileremark
        });
        // Clear files after successful upload
        this.localFileuplaoded = [];
        this.localResetFlag = !this.localResetFlag; // Force DragDropfile to clear UI
        return true;
      } finally {
        this.sendforreviewloading = false;
      }
    },
    // Internal helper to support suppressing snackbar when auto-submitting
    async uploadFilesInternal(suppressSnackbar) {
      this.sendforreviewloading = true;
      try {
        await this.$store.dispatch('tasks/uploadFiles', {
          id: this.id,
          files: this.localFileuplaoded,
          taskData: this.task,
          projectId: this.id,
          upload_v2: this.task.upload_v2,
          isFileValid: this.isFileValid,
          suppressSnackbar,
          remark: this.localFileremark
        });
        this.localFileuplaoded = [];
        this.localResetFlag = !this.localResetFlag;
        return true;
      } finally {
        this.sendforreviewloading = false;
      }
    },
    async uploadFilesBulk() {
      // Now handled by Vuex action. Just dispatch and handle loading state.
      this.sendforreviewloadingbulk = true;
      try {
        const newFilesCount = Array.isArray(this.localFileuplaoded) ? this.localFileuplaoded.length : 0;
        const result = await this.$store.dispatch('tasks/uploadFilesBulk', {
          files: this.localFileuplaoded,
          id: this.id,
          selectItem: this.selectItem,
          viewtaskdata: this.task,
          isFileValid: this.isFileValid,
          remark: this.localFileremark,
          suppressSnackbar: this.showUploadAndSubmit && !this.localUploadWithoutFile
            && this.pageType !== 'task-detail'
            && this.getSubmitTargets(this.selectItem, newFilesCount).length > 0,
        });
        if (result && result.success) {
          const tasksToConsider = (Array.isArray(this.selectItem) && this.selectItem.length) ? this.selectItem : [this.task];
          const attemptAutoSubmit = !this.localUploadWithoutFile; // don't auto-submit when remark-only
          await this.afterUploadSuccess({ tasks: tasksToConsider, newFilesCount: newFilesCount, isBulk: true, attemptAutoSubmit });
          // Clear local selections/files after successful bulk upload
          this.localFileuplaoded = [];
          this.selectItem = [];
          this.localFileremark = '';
          this.localUploadWithoutFile = false;
          this.localResetFlag = !this.localResetFlag;
          this.drawerVisible = false; // Close drawer after upload success
          this.$emit(COMPONENT_EVENTS.BULK_UPLOAD_COMPLETE);
          this.$emit(COMPONENT_EVENTS.CLEAR_SELECTED);
          this.$emit(COMPONENT_EVENTS.REFRESH); // Emit event to parent for forced refresh
        }
      } finally {
        this.sendforreviewloadingbulk = false;
      }
      this.localResetFlag = !this.localResetFlag;
    },
    removeAllInvalidFiles() {
      this.localFileuplaoded = this.localFileuplaoded.filter(f => this.isFileValid(f));
      this.FilesUpload(this.localFileuplaoded);
    },
    isFileValid(file) {
      if (!file.name) return false;
      const validName = this.$nova && this.$nova.isValidFileName ? this.$nova.isValidFileName(file.name) : true;
      const ext = file.name.split('.').pop().toLowerCase();
      const validExt = this.ALLOWED_EXTENSIONS.includes(ext);
      return validName && validExt;
    },
  },
}
</script>

<style scoped>
.d-cont{
  display: contents !important;
}
</style>